import React, { ReactNode } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { PrimaryButton, SecondaryButton } from './ConfirmationPopup.styled';

interface ConfirmationPopupProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: ReactNode;  // Thay 'string' thành 'ReactNode' để hỗ trợ JSX
    onConfirm: () => void;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({ isOpen, onClose, title, message, onConfirm }) => {
    return (
        <Modal isOpen={isOpen} toggle={onClose}>
            <ModalHeader toggle={onClose}>
                {title}
            </ModalHeader>
            <ModalBody>
                {message} {/* Có thể hiển thị JSX ở đây */}
            </ModalBody>
            <ModalFooter>
                <PrimaryButton onClick={onConfirm}>
                    Có
                </PrimaryButton>
                <SecondaryButton onClick={onClose}>
                    Không
                </SecondaryButton>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmationPopup;
